import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

export default makeStyles((theme) => ({
  subTitle: {
    color: theme.palette.grey[500],
  },
}));
